/**
 * @description
 * @author
 * @date
 */

import 'raf/polyfill';

if (!Element.prototype.remove) {
    Element.prototype.remove = function() {
        const element = this as Element;
        if (element.parentNode) {
            element.parentNode.removeChild(element);
        }
    };
}
